import type { Observable } from "rxjs";

import type { RewardsVipTierEntity } from "./models/RewardsVipTiersEntities";

export enum REWARDS_VIP_TIERS_CONDITION_TYPES {
    points = "earn_points",
    purchasesMade = "purchases_made",
    spentAmount = "spent_amount",
    customerTag = "customer_tag",
    completedReferrals = "completed_referrals",
}

export type RewardsVipTiersQueryParams = {
    locale: string;
};

export type ObservableCustomerNextTierType = Observable<
    RewardsVipTierEntity | undefined
>;
